<template>
  <b-overlay :show="deleting">
    <template #overlay>
      <div class="text-center">
        <b-icon-x-square-fill
          font-scale="3"
          animation="throb"
          :variant="variant"
        ></b-icon-x-square-fill>
        <p>{{ btntext }}ing... {{ btntext2 }}</p>
      </div>
    </template>

      <div class="event-card -shadow p-2 m-2">
        <span class="eyebrow"
          >{{ question.category }} for {{ question.institution }}</span
        >
        <h4 class="title mt-1">{{ question.subject }} Question</h4>
        <b-row>
          <b-col cols="8">
            <h6 class="title pt-2" v-html="question.question">Question :</h6>
          </b-col>
          <b-col cols="4">
            <b-button :variant="variant" @click.prevent="queDelete">{{
              btntext
            }}</b-button>
            <br>

            <b-button class="mt-3" :variant="variant2" @click.prevent="chgAvail">{{
              btntext2
            }}</b-button>
          </b-col>
        </b-row>
      </div>

  </b-overlay>
</template>

<script>
import { mapActions  } from "vuex";

export default {
  props: ["question"],
  data() {
    return {
      deleting: false,
    };
  },
  methods: {
    ...mapActions("admin", ["perfDelete", "fetchQuestionsall", "chngAvail"]),
    queDelete() {
      this.deleting = true;
      let action = "";
      if (this.question.is_deleted == "Yes") {
        action = "Undelete";
      } else {
        action = "Delete";
      }
      let delobj = {
        action,
        trackid: this.question.track_id,
      };
      //console.log(delobj);
      return this.perfDelete(delobj).then(() => {
        //this.fetchQuestionsall();
        this.$emit("refac");
        this.deleting = false;
        //console.log(response.data);
      });
    },
    chgAvail() {
      this.deleting = true;
      let action = "";
      if (this.question.available == "Premium") {
        action = "freeise";
      } else {
        action = "premiumise";
      }
      let delobj = {
        action,
        trackid: this.question.track_id,
      };
      //console.log(delobj);
      
      return this.chngAvail(delobj).then(() => {
        //this.fetchQuestionsall();
        this.$emit("refac");
        this.deleting = false;
        //console.log(response.data);
      });
    },
  },
  computed: {
    variant() {
      if (this.question.is_deleted == "Yes") {
        return "info";
      } else {
        return "danger";
      }
    },
    variant2() {
      if (this.question.available == "Premium") {
        return "warning";
      } else {
        return "primary";
      }
    },
    btntext() {
      if (this.question.is_deleted == "Yes") {
        return "Undelete";
      } else {
        return "Delete";
      }
    },
    btntext2() {
      if (this.question.available == "Premium") {
        return "Premium";
      } else {
        return "Free";
      }
    },
  },
};
</script>

<style scoped>
.icon {
  width: 25px;
  height: 25px;
  margin-right: 5px;
}

.event-card {
  transition: all 0.2s linear;
  cursor: pointer;
  background-color: lightgray;
  border-radius: 10px 10px;
}

.event-card:hover {
  transform: scale(1.01);
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2), 0 1px 15px 0 rgba(0, 0, 0, 0.19);
}

.event-link {
  color: black;
  text-decoration: none;
}
</style>
